import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';

@Injectable({
  providedIn: 'root'
})

export class TaskResolve  {
    constructor(private apiService: ApiServiceService) { }
    resolve(route: ActivatedRouteSnapshot) {
      if(route.params['taskId'] !=='' && route.params['taskId'] !== undefined){
        return this.apiService.get('tasks', route.params['taskId'])
            .then((data:any)=>{
              return data;
            })
      }else{
          return null;
      }
    }

}
